var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 7410 3900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b22234",
    d: "M0 0h7410v3900H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0",
    stroke: "#fff",
    strokeWidth: 300
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b6e",
    d: "M0 0h2964v2100H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M247 90l70.534 217.082-184.66-134.164h228.253L176.466 307.082z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 420
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 1260
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 1680
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 247,
    y: 210
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 494
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 988
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 1976
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 2470
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.d21917ae9982e6ddb4522ce72f25de19.svg";
export { ForwardRef as ReactComponent };